import { PINJAMAN } from "../../constants/admin/masterdata/constants";

const initialState = {
  cache: {},
  queryKey: null,
  selectedIds: [],
  isModalAction: false,
  loadingGetPinjaman: true,
  loadingActionPinjaman: false,
  dataPinjaman: { count: 0, data: [] },
  detailPinjaman: null,
  loadingDetail: false,
  detailError: null,
  loadingCreateInstallment: false,
  createInstallmentData: null,
  createInstallmentError: null,
  loadingImportInstallment: false,
  importInstallmentData: null,
  importInstallmentError: null,
  loadingUpdateLoan: false,
  updateLoanData: null,
  updateLoanError: null,
};

export const pinjamanReducer = (state = initialState, action) => {
  switch (action.type) {
    case PINJAMAN.GET_DATA_PINJAMAN_SUCCESS:
      return {
        ...state,
        dataPinjaman: action.data || { count: 0, data: [] },
      };

    case PINJAMAN.LOADING_IMPORT_INSTALLMENT:
      return {
        ...state,
        loadingImportInstallment: action.load,
      };

    case PINJAMAN.IMPORT_INSTALLMENT_SUCCESS:
      return {
        ...state,
        importInstallmentData: action.data,
        importInstallmentError: null,
      };

    case PINJAMAN.LOADING_CREATE_INSTALLMENT:
      return {
        ...state,
        loadingCreateInstallment: action.load,
      };

    case PINJAMAN.CREATE_INSTALLMENT_SUCCESS:
      return {
        ...state,
        createInstallmentData: action.data,
        createInstallmentError: null,
      };

    case PINJAMAN.LOADING_DATA_PINJAMAN_SUCCESS:
      return {
        ...state,
        loadingGetPinjaman: action.load,
      };

    case PINJAMAN.LOADING_ACTION_PINJAMAN:
      return {
        ...state,
        loadingActionPinjaman: action.load,
      };

    case PINJAMAN.IS_MODAL_ACTION_PINJAMAN:
      return {
        ...state,
        isModalAction: action.load,
      };

    case PINJAMAN.SET_QUERY_KEY: {
      if (state.queryKey !== action.key) {
        return { ...state, queryKey: action.key, selectedIds: [] };
      }
      return state;
    }

    case PINJAMAN.ADD_SELECTED_IDS: {
      const set = new Set(state.selectedIds);
      (action.ids || []).forEach((id) => set.add(id));
      return { ...state, selectedIds: Array.from(set) };
    }

    case PINJAMAN.REMOVE_SELECTED_IDS: {
      const removeSet = new Set(action.ids || []);
      const next = state.selectedIds.filter((id) => !removeSet.has(id));
      return { ...state, selectedIds: next };
    }

    case PINJAMAN.CLEAR_SELECTED_IDS:
      return { ...state, selectedIds: [] };

    case PINJAMAN.SET_CACHE_ENTRY: {
      const { key, data } = action;
      return {
        ...state,
        cache: {
          ...state.cache,
          [key]: { data, fetchedAt: Date.now(), loading: false },
        },
        dataPinjaman: data || { count: 0, data: [] },
        loadingGetPinjaman: false,
      };
    }

    case PINJAMAN.SET_LOADING_FOR_KEY: {
      const { key, loading } = action;
      const prev = state.cache[key] || {};
      return {
        ...state,
        cache: { ...state.cache, [key]: { ...prev, loading } },
        loadingGetPinjaman: loading,
      };
    }

    case PINJAMAN.UPDATE_CACHE_ITEMS: {
      const { changesById } = action;
      const nextCache = {};
      for (const k in state.cache) {
        const entry = state.cache[k];
        if (!entry?.data?.data) {
          nextCache[k] = entry;
          continue;
        }
        const newList = entry.data.data.map((row) =>
          changesById[row.id] ? { ...row, ...changesById[row.id] } : row,
        );
        nextCache[k] = {
          ...entry,
          data: { ...entry.data, data: newList },
        };
      }
      const activeList = state.dataPinjaman?.data || [];
      const newActive = activeList.map((row) =>
        changesById[row.id] ? { ...row, ...changesById[row.id] } : row,
      );
      return {
        ...state,
        cache: nextCache,
        dataPinjaman: {
          ...state.dataPinjaman,
          data: newActive,
        },
      };
    }

    case PINJAMAN.GET_DETAIL_PINJAMAN_SUCCESS:
      return {
        ...state,
        detailPinjaman: action.data,
        loadingDetail: false,
        detailError: null,
      };

    case PINJAMAN.LOADING_DETAIL_PINJAMAN:
      return {
        ...state,
        loadingDetail: action.load,
      };

    case PINJAMAN.SET_DETAIL_ERROR:
      return {
        ...state,
        detailError: action.error,
        loadingDetail: false,
      };

    case PINJAMAN.LOADING_UPDATE_LOAN:
      return {
        ...state,
        loadingUpdateLoan: action.load,
      };

    case PINJAMAN.UPDATE_LOAN_SUCCESS: {
      const nextDetail = state.detailPinjaman
        ? {
            ...state.detailPinjaman,
            data: action.data,
          }
        : state.detailPinjaman;

      return {
        ...state,
        updateLoanData: action.data,
        updateLoanError: null,
        detailPinjaman: nextDetail,
      };
    }

    default:
      return state;
  }
};
